var navMaxHeight;
var navOriginalHeight = $(".navbar-collapse").height();
var isNavMenuExpanded = false;
$(window).on("load", function () {
    var footerHeight = $(".footer").height();
    // @ts-ignore 
    $("#bodyContent").css("margin-bottom", footerHeight);
    // Enable tooltips
    // @ts-ignore 
    // $("[data-toggle='tooltip']").tooltip();
    // @ts-ignore 
    resizeContent();
    styleActiveMenu();
    setupLanguageControl();
});
$(function () {
    $(window).resize(function () {
        // @ts-ignore 
        resizeContent();
    });
    // Resize when bootstrap divs are hidden/shown (i.e. faq's page & mobile menu)
    $("body").on("shown.bs.collapse", function () {
        // @ts-ignore 
        resizeContent();
    });
    $("body").on("hidden.bs.collapse", function () {
        // @ts-ignore 
        resizeContent();
    });
    var wasNavMenuVisible = $(".navbar-toggler").is(":visible");
    // Slide elements with position set to fixed or absolute with the rest of the
    // page when expanding/collapsing the bootstrap small screen nav menu
    $(window).resize(function () {
        var headerHeight = $(".navbar-collapse").height();
        // @ts-ignore 
        if (!navMaxHeight || headerHeight > navOriginalHeight) {
            navMaxHeight = headerHeight;
        }
        if (!$(".navbar-toggler").is(":visible")) {
            if (wasNavMenuVisible) {
                // Slide the items back up again if the window was expanded with the menu open
                $(".slide-with-header.menu-down").each(function () {
                    $(this).removeClass("menu-down");
                    $(this).css("top", "-=" + navMaxHeight);
                });
            }
        }
        else {
            // Slide down again if the menu is expanded when resizing
            if (!wasNavMenuVisible && isNavMenuExpanded) {
                $(".slide-with-header").each(function () {
                    if (!$(this).hasClass("menu-down")) {
                        $(this).addClass("menu-down");
                        $(this).css("top", "+=" + navMaxHeight);
                    }
                });
            }
        }
        wasNavMenuVisible = $(".navbar-toggler").is(":visible");
    });
    // slide any 'absolute' or 'fixed' positioned divs when opening/closing bootstrap navbar
    $(".navbar-toggler").on("click", function () {
        slideFixedContentWithNav();
    });
    $(".nav-item.dropdown").on("shown.bs.dropdown", function () {
        slideFixedContentWithSubNav(this);
    });
    $(".nav-item.dropdown").on("hidden.bs.dropdown", function () {
        slideFixedContentWithSubNav(this);
    });
});
function slideFixedContentWithSubNav(element) {
    var nav = $(".navbar-collapse");
    // Don't do anything if the dropdown menu isn't visible
    if ($(".navbar-toggler-icon").is(":visible") && nav.hasClass("show")) {
        var navItem = $(element);
        var originalHeight = navMaxHeight;
        var totalHeight = $(".navbar-collapse").height();
        // @ts-ignore 
        var valueToSlide = totalHeight - originalHeight;
        navMaxHeight = totalHeight;
        if (navItem.parent().hasClass("show")) {
            $(".slide-with-header").each(function () {
                // closing bootstrap nav - slide elements up
                $(this).css({
                    top: "-=" + valueToSlide,
                    WebkitTransition: "left 800ms",
                    MozTransition: "left 800ms",
                    MsTransition: "left 800ms",
                    OTransition: "left 800ms",
                    transition: "left 800ms"
                });
            });
        }
        else {
            $(".slide-with-header").each(function () {
                // opening bootstrap nav - slide elements down
                $(this).css({
                    top: "+=" + valueToSlide,
                    WebkitTransition: "left 800ms",
                    MozTransition: "left 800ms",
                    MsTransition: "left 800ms",
                    OTransition: "left 800ms",
                    transition: "left 800ms"
                });
            });
        }
    }
}
function slideFixedContentWithNav() {
    var nav = $(".navbar-collapse");
    var headerHeight = nav.height();
    // @ts-ignore 
    if (!navMaxHeight || headerHeight > navOriginalHeight) {
        navMaxHeight = headerHeight;
    }
    if (nav.hasClass("show")) {
        $(".slide-with-header").each(function () {
            // closing bootstrap nav - slide elements up
            $(this).css({
                top: "-=" + navMaxHeight,
                WebkitTransition: "left 800ms, top 0.3s",
                MozTransition: "left 800ms, top 0.3s",
                MsTransition: "left 800ms, top 0.3s",
                OTransition: "left 800ms, top 0.3s",
                transition: "left 800ms, top 0.3s"
            });
            if ($(this).addClass("menu-down")) {
                $(this).removeClass("menu-down");
            }
        });
        isNavMenuExpanded = false;
    }
    else {
        $(".slide-with-header").each(function () {
            // opening bootstrap nav - slide elements down
            $(this).css({
                top: "+=" + navMaxHeight,
                WebkitTransition: "left 800ms, top 0.3s",
                MozTransition: "left 800ms, top 0.3s",
                MsTransition: "left 800ms, top 0.3s",
                OTransition: "left 800ms, top 0.3s",
                transition: "left 800ms, top 0.3s"
            });
            $(this).addClass("menu-down");
        });
        isNavMenuExpanded = true;
    }
}
function setupLanguageControl() {
    $(".language-selector a").on("click", function () {
        setLanguage($(this).html());
    });
}
function setLanguage(lang) {
    $.ajax({
        type: "POST",
        url: "/home/setlanguage?lang=" + lang,
        success: function (response) {
            location.reload();
        },
        error: function () {
            console.log("An error has occured while setting language.");
        }
    });
}
/**
 * Finds and sets styling for active nav based on presence of value of
 * <input type="hidden" id="activeMenu" value="properties-page" />
 * element
 */
function styleActiveMenu() {
    var hdnActiveMenu = $("#activeMenu");
    if (hdnActiveMenu) {
        var activeMenuId = hdnActiveMenu.val();
        var activeMenu = $("#" + activeMenuId);
        if (activeMenu) {
            activeMenu.addClass("is-active");
        }
    }
}
/**
 * Resize the content on the page, usually in response to
 * page re-sizing.
 * */
function resizeContent() {
    let bodyHeight = $("body").height();
    let windowHeight = $(window).height();
    let footerHeight = $(".footer").height();
    if ($(".footer").hasClass("footer-fixed")) {
        // @ts-ignore 
        if ((bodyHeight + footerHeight) > windowHeight) {
            $(".footer").removeClass("footer-fixed");
            $("#bodyContent").css("margin-bottom", "6px");
        }
    }
    else {
        // @ts-ignore 
        if (bodyHeight > windowHeight) {
            $(".footer").removeClass("footer-fixed");
            $("#bodyContent").css("margin-bottom", "6px");
        }
        else {
            $(".footer").addClass("footer-fixed");
            // @ts-ignore 
            $("#bodyContent").css("margin-bottom", footerHeight);
        }
    }
}
// these functions are available globally (i.e. from HTML)
window.resizeContent = resizeContent;
/**
 * Selects a dom element and throws an error if it is null.
 * @param id DOM element ID.
 */
export function getDomElementAsNotNullable(id) {
    let el = document.getElementById(id);
    if (el === null) {
        throw new Error(`Element with id: ${id} not found`);
    }
    else {
        return el;
    }
}
